import { disableFetchingOverlay, enableFetchingOverlay } from '../actions/ui';
import store from '../store/store';
import fetch from './fetch';

export function downloadFile(path, name, withPrefix = true) {
  // const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
  // const isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
  const apiHost = process.env.BACKEND_URL;
  const apiPrefix = '/api';
  const uri = withPrefix ? (apiHost + apiPrefix + path) : path;

  //todo probably rewrite it in iframe methods
  // if (isChrome || isSafari) {
  //   const link = document.createElement('a');
  //   link.download = name;
  //   link.href = uri;
  //   // link.target = '_blank';
  //   link.click();
  // } else {
  window.open(uri);
  // }
}

export const downloadFiles = ({
  id, txId, formData = {}, step = 'precheque', withOverlay = true, overlayMessageShowTime = 6000, withPolling = true,
}) => {
  const maxPollAttempts = 10;
  const pollInterval = 10000;
  const complexSalesGuid = window.sessionStorage.getItem('complexSalesGuid');

  if (withOverlay) {
    store.dispatch(enableFetchingOverlay({
      message: 'Скачивание документа заняло больше времени,<br />чем ожидалось. Осталось совсем немного!',
      messageShowTime: overlayMessageShowTime,
    }));
  }

  const executeDownload = (attempt = 1) => fetch(`/attachments/${id}`, {
    method: 'POST',
    body: {
      ...formData,
      step,
      txId,
    },
  })
    .then((links) => {
      if (links.result && links.result.length > 0) {
        if (withOverlay) {
          store.dispatch(disableFetchingOverlay());
        }

        links.result.forEach((link) => {
          downloadFile(`/attachments/${link}`, link);
        });
        return links;
      }

      if (step !== 'precheque' && attempt < maxPollAttempts && complexSalesGuid && complexSalesGuid !== '0') {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(executeDownload(attempt + 1));
          }, pollInterval);
        });
      }

      return Promise.reject(new Error('Файлы не найдены'));
    })
    .catch((error) => {
      if (withOverlay) {
        store.dispatch(disableFetchingOverlay());
      }
      return Promise.reject(error);
    });

  return executeDownload();
};

export const blank = () => {};
